module.exports = __webpack_public_path__ + "img/empty-md-data.png?fa94b92e";